import { createSelector } from 'reselect'

const getFilteredEntities = (state, entityKey, filters = []) => {
  const filtered = {}
  const entities = state.entities[entityKey]
  const keys = Object.keys(entities)
  const filterCount = filters.length

  keys.forEach((key) => {
    let passedFilters = 0
    const entity = entities[key]

    filters.forEach(({ key: filterKey, value }) => {
      const result = value === null
        ? entity[filterKey] === value
        : typeof entity[filterKey] !== 'undefined' && entity[filterKey] === value

      if (result){
        passedFilters += 1
      }
    })

    if (passedFilters === filterCount){
      filtered[key] = entity
    }
  })

  return filtered
}

const multiFilteredObjectsSelector = createSelector([getFilteredEntities], entities => entities)

export default multiFilteredObjectsSelector
